// courses/course_S02.ts

export const course_S02 = `
  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">1. 음방 타임테이블(큐시트) 읽는 법</h4>
    <p style="margin-bottom: 10px; line-height: 1.6;">방송국에 도착하면 가장 먼저 확인해야 할 것이 그날의 '큐시트'와 '타임테이블'입니다.</p>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>드라이 리허설(Dry Rehearsal):</strong> 의상을 입지 않고 무대 동선과 마이크 상태만 체크하는 시간입니다. 매우 빠르게 진행되므로 5분 전 대기는 필수입니다.</li>
      <li style="margin-bottom: 8px;"><strong>카메라 리허설(Camera Rehearsal):</strong> 실제 의상을 갖춰 입고 카메라 앵글을 맞추는 시간입니다. 이때 매니저는 모니터링을 통해 아티스트가 화면에 어떻게 나오는지 확인해야 합니다.</li>
      <li style="margin-bottom: 8px;"><strong>사전 녹화(Pre-recording):</strong> 생방송 시간 관계상 미리 녹화하는 과정입니다. 팬들과 함께 진행되는 경우가 많아 현장 통제가 중요합니다.</li>
      <li><strong>본방송(Live):</strong> 실제 생방송 시간입니다. 출연 순서에 맞춰 무대 뒤(스테이지 백)에서 대기하는 타이밍을 정확히 맞춰야 합니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">2. 방송국 대기실 매너: "공유 공간의 예절"</h4>
    <p style="margin-bottom: 10px; line-height: 1.6;">대기실은 우리 팀만 쓰는 곳이 아닙니다. 다른 가수, 스태프들과 함께 사용하는 공간임을 명심해야 합니다.</p>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>인사 예절:</strong> 대기실 복도에서 마주치는 타사 가수, 매니저, 방송국 작가 및 PD님들에게 밝게 인사하는 것은 기본 중의 기본입니다. 이는 팀의 평판과 직결됩니다.</li>
      <li style="margin-bottom: 8px;"><strong>복도 및 통로 확보:</strong> 대기실 앞 복도에 짐을 쌓아두거나 앉아있어 통행을 방해해서는 안 됩니다. 방송국 복도는 장비 이동이 잦아 사고의 위험이 있습니다.</li>
      <li><strong>음식물 관리:</strong> 냄새가 심한 음식은 피하고, 식사 후 뒷정리는 매니저가 직접 완벽하게 처리하여 다음 팀이나 청소 스태프에게 불편을 주지 않습니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">3. 무대 뒤(Backstage) 수칙</h4>
    <p style="margin-bottom: 10px; line-height: 1.6;">무대 바로 뒤는 어둡고 위험한 장비가 많으며, 긴장감이 극도로 높은 곳입니다.</p>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>정숙 유지:</strong> 무대 위에서 다른 팀이 공연 중일 때 큰 소리로 떠들거나 웃는 행위는 절대 금물입니다. 마이크를 통해 소음이 들어갈 수 있습니다.</li>
      <li style="margin-bottom: 8px;"><strong>소지품 회수:</strong> 아티스트가 무대에 올라가기 직전 벗어두는 외투, 핸드폰, 인이어 케이스 등을 신속하게 챙겨 무대 이동에 방해가 되지 않게 합니다.</li>
      <li><strong>엔딩 요정 및 전체 대기:</strong> 생방송 마지막에 모든 출연진이 무대에 올라가는 '엔딩' 타이밍을 놓치지 않도록 아티스트를 미리 준비시킵니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">4. 방송국 관계자(작가/PD)와의 소통</h4>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>수정 사항 체크:</strong> 작가님이 전달하는 대본 수정이나 큐시트 변경 사항을 즉시 기록하고 아티스트에게 전달합니다.</li>
      <li><strong>협조적인 태도:</strong> 무대 세트 설치나 리허설 지연 등 방송국 사정으로 일정이 변동될 때, 불만을 표시하기보다 유연하게 대처하며 관계자들과 좋은 관계를 유지합니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">5. 왜 이 수칙이 중요한가?</h4>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>방송 사고 방지:</strong> 타임테이블을 잘못 읽어 출연 순서를 놓치는 것은 매니저로서 치명적인 실수입니다.</li>
      <li><strong>차기 출연 기회:</strong> 방송국 제작진은 실력만큼이나 매너 좋은 팀을 선호합니다. 대기실과 무대 뒤에서의 태도가 다음 앨범 활동 시 출연 섭외에 영향을 미칩니다.</li>
    </ul>
  </div>

  <div style="background-color: #f0f9ff; padding: 20px; border-radius: 12px; border-left: 5px solid #0284c7; margin-top: 30px;">
    <strong style="color: #0369a1; font-size: 1.1rem; display: block; margin-bottom: 10px;">💡 교육생을 위한 한 줄 요약</strong>
    <p style="margin: 0; color: #334155; font-style: italic; line-height: 1.6;">
      "방송국은 아티스트가 실력을 뽐내는 무대이지만, 매니저에게는 실무 능력과 인성이 동시에 평가받는 시험대입니다."
    </p>
  </div>
`;